import common from "../common";


export default class SoundManager
{
    constructor()
    {
        this.sounds = {};
        this.audioBlocked = true;

        var hidden;
        "undefined" != typeof document.hidden ? (hidden = "hidden",
            this.visibilityChange = "visibilitychange")     : "undefined" != typeof document.mozHidden  ? (hidden = "mozHidden",
            this.visibilityChange = "mozvisibilitychange")  : "undefined" != typeof document.msHidden   ? (hidden = "msHidden",
            this.visibilityChange = "msvisibilitychange")   : "undefined" != typeof document.webkitHidden && (hidden = "webkitHidden",
            this.visibilityChange = "webkitvisibilitychange");
    
        document.addEventListener(this.visibilityChange, function(){
            document[hidden] ? Howler.volume(0) : Howler.volume(1);
        }, false);
    }

    loadSounds(sounds)
    {
        for(var i in sounds)
        {
            this.sounds[sounds[i].id] = new Howl({
                src: sounds[i].url,
                volume: 1.0,
                loop: sounds[i].loop,
                autoplay: false
            });
            this.sounds[sounds[i].id].on('play', function(){
                this.audioBlocked = false;
            }.bind(this));
        }
    }

    play(soundId)
    {
        if(common.basicMode)
            return;

        if(typeof soundId == 'object')
        {
            soundId = soundId[Math.floor(Math.random() * soundId.length)];
        }
        this.sounds[soundId].play();

        return this.sounds[soundId];
    }

    mute()
    {
        Howler.mute(true);
    }

    unmute()
    {
        Howler.mute(false);
    }
}